/**
 * Normalise l'utilisateur de session.
 * /auth/login renvoie un user Supabase avec `id`.
 * /auth/me renvoyait seulement `user_id` : le frontend lisait `user.id` et le perdait.
 */
export function getUserId(user) {
  if (!user || typeof user !== 'object') return null
  return user.id || user.user_id || user.sub || null
}

export function normalizeUser(user) {
  if (!user || typeof user !== 'object') return null
  const id = getUserId(user)
  const next = id ? { ...user, id, user_id: user.user_id || id } : { ...user }
  if (Object.prototype.hasOwnProperty.call(user, 'is_admin')) {
    next.is_admin = Boolean(user.is_admin)
  }
  return next
}

export function resolveProfileUserId(selectedUserId, user, storedSelected, storedLastViewed) {
  return selectedUserId || getUserId(user) || storedSelected || storedLastViewed || null
}

export function canReusePreviousQueryData(previousQuery, userId) {
  if (!previousQuery || !userId) return false
  const previousUserId = previousQuery.queryKey?.[1]
  return previousUserId === userId
}

export const PRIVATE_SESSION_STORAGE_KEYS = [
  'social_selectedUserId',
  'social_lastViewedUserId',
  'social_lastActiveTab',
  'remembered_pwd',
]

export function clearPrivateSessionArtifacts() {
  try {
    PRIVATE_SESSION_STORAGE_KEYS.forEach((key) => localStorage.removeItem(key))
    Object.keys(sessionStorage)
      .filter((key) => key.startsWith('budget-opt-last-result:'))
      .forEach((key) => sessionStorage.removeItem(key))
  } catch (_) {
    /* ignore quota / mode privé */
  }
}
